// extracted by mini-css-extract-plugin
module.exports = {"AmendPassengerDetailsForm":"styles_AmendPassengerDetailsForm__2N1N7","alternativeContactsWrap":"styles_alternativeContactsWrap__242cw"};